import { useState } from 'react';

import { SwiperSlideChangedCbProps } from 'Components/common/customSwiper/interface';

export const useSwiperArrows = (): {
	showLeftArrow: boolean;
	showRightArrow: boolean;
	onSlideChanged: (args: Omit<SwiperSlideChangedCbProps, 'index'>) => void;
} => {
	const [showLeftArrow, setShowLeftArrow] = useState(false);
	const [showRightArrow, setShowRightArrow] = useState(false);

	const onSlideChanged = ({
		isLeftArrowEnabled,
		isRightArrowEnabled,
	}: Omit<SwiperSlideChangedCbProps, 'index'>) => {
		setShowLeftArrow(isLeftArrowEnabled);
		setShowRightArrow(isRightArrowEnabled);
	};

	return {
		showLeftArrow,
		showRightArrow,
		onSlideChanged,
	};
};
